import { Grid } from "@mui/material";
import FormBuilderComponent from "components/FormBuilder/FormBuilder";
import FormEditor from "components/FormBuilder/FormEditor";
import CustomPageLayout from "examples/LayoutContainers/CustomPageLayout";
import React from "react";
import MDBox from "components/MDBox";
import Card from "@mui/material/Card";
import MDTypography from "components/MDTypography";

const EditForm = () => {
  return (
    <CustomPageLayout>
    <MDBox pt={3} pb={3}>
      <Card>
        <MDBox p={3} lineHeight={1}>
          <Grid container justifyContent="space-between" spacing={3}>
            <Grid item>
              <MDTypography variant="h5" fontWeight="medium">
                Edit Form
              </MDTypography>
              <MDTypography variant="button" color="text">
                Here you can edit form.
              </MDTypography>
            </Grid>
          </Grid>
        </MDBox>
        <MDBox p={3} lineHeight={1}>
          <FormEditor />
        </MDBox>
      </Card>
    </MDBox>
  </CustomPageLayout>
  );
};

export default EditForm;
